import fetch from '@/utils/fetch'

// 列表
export const listUrl = '/aftersales/setting/product/store/return/list'

// 删除商品
export function deleteAftersales (params) {
  return fetch({
    url: '/aftersales/setting/product/store/return',
    method: 'delete',
    params
  })
}

// 修改
export function updateAftersales (params) {
  return fetch({
    url: '/aftersales/setting/product/store/return/status',
    method: 'put',
    params
  })
}
